import React, { Fragment, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import { fetchData, deleteData, activateData, postData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AsyncSelect from 'react-select/async';


export const CustomerCreate = (props) => {
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false);

    /* API Call Post Method */
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
        }
    }, [isAuthenticated, companyId, token, logout]);

    //Customer create
    const [names, setNames] = useState("");
    const [emails, setEmails] = useState("");
    const [gstNumbers, setGstNumbers] = useState("");
    const [contactNumber1s, setContactNumber1s] = useState("");
    const [contactNumber2s, setContactNumber2s] = useState("");
    const [addressline1s, setAddressLine1s] = useState("");
    const [addressline2s, setAddressLine2s] = useState("");
    const [landMarks, setLandMarks] = useState("");
    const [towns, setTowns] = useState("");
    const [pincodes, setPostcodes] = useState("");
    const [contactPersons, setcontactPersons] = useState("");
    const [districts, setDistricts] = useState("");
    const [states, setStates] = useState("");
    const [countrys, setCountrys] = useState("");
    const [pinCodess, setPinCodess] = useState([]);
    const [Gst, setGst] = useState("");
    const [successMessages, setSuccessMessages] = useState("");
    const [errorMessages, setErrorMessages] = useState("");
    const [openingbal, setOpeningBalance] = useState([]);
    const [Remarks, setRemarks] = useState([]);
    const [customerpricetype, setCustomerpricetype] = useState([]);//Customerpricetype
    const [openingTime, setOpeningTime] = useState("");
    const [TallyId, settallyId] = useState("");
    const [LunchBreak, setLunchBreak] = useState("");
    const [customerReview, setCustomerReview] = useState(0);


    //customer Route


    //const [pinCodess, setPinCodess] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);

    const fetchOptions = async (inputValue) => {
        if (inputValue.length <= 4) {
            return [];
        }

        const response = await fetchData('PinCodeApi', `/${companyId}/${inputValue}`, token);
        if (response) {
            const data = await response;
            setPinCodess(data);  // Move this line outside the if block
            return data.map(item => ({
                value: item.id,
                label: item.postcode,
            }));
        }
        return [];
    };

    const handleInputChange = (newValue) => newValue;

    const handleChangeDrop = (selectedOption) => {
        setSelectedOption(selectedOption);
        const selectedItemDetail = pinCodess.find(pincode => pincode.id === selectedOption.value);
        if (selectedItemDetail) {
            setTowns(selectedItemDetail.city);
            setDistricts(selectedItemDetail.district);
            setPostcodes(selectedItemDetail.postcode);
            setCountrys(selectedItemDetail.country);
            setStates(selectedItemDetail.state);
        }

    };


    const [selectedRoute, setSelectedRoute] = useState("");
    const [routeOptions, setRouteOptions] = useState([]);
    const [selectedRouteType, setSelectedRouteType] = useState("");

    const fetchRouteTypes = async () => {
        try {
            const response = await fetchData('RouteApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(route => ({
                    value: route.id,
                    label: route.name
                }));
                setRouteOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handleRouteTypeChange = (selectedOption) => {
        setSelectedRouteType(selectedOption);
    };

    useEffect(() => {
        fetchRouteTypes();
    }, []);

    const [selectedPaymentType, setSelectedPaymentType] = useState("1");
    const handleChange = (event) => {
        setSelectedPaymentType(event.target.value);

    };

    //customer Payment Method 

    const [selectedPaymentmethod, setSelectedPaymentmethod] = useState("");
    const [paymentmethodOptions, setPaymentmethodOptions] = useState([]);
    const [selectedPaymentmethodType, setSelectedPaymentmethodType] = useState("");

    const fetchPaymentmethodTypes = async () => {
        try {
            const response = await fetchData('PaymentMethodApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(method => ({
                    value: method.Id,
                    label: method.Name
                }));
                setPaymentmethodOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };
    const handlePaymentTypeChange = (selectedOption) => {
        setSelectedPaymentmethodType(selectedOption);
    };

    useEffect(() => {
        fetchPaymentmethodTypes();
        fetchCustomerTypes();
    }, []);

    //customer type

    const [customerTypeOptions, setCustomerTypeOptions] = useState([]);
    const [selectedCustomerType, setSelectedCustomerType] = useState("");

    const fetchCustomerTypes = async () => {
        try {
            const response = await fetchData('CustomerTypeApi', `/${companyId}`);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(customer => ({
                    value: customer.id,
                    label: customer.type
                }));
                setCustomerTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Customer Types:', error);
        }
    };
    const handleCustomerTypeChange = (selectedOption) => {
        setSelectedCustomerType(selectedOption);
    };



    const submitData = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        // Validate only the required fields
        if (!names || !selectedPaymentmethodType || !selectedCustomerType) {
            setErrorMessages("Name, Payment Method, and Customer Type are required!");
            setIsLoading(false);
            return;
        }

        try {

            const CustomerCreateData = {
                Name: names,
                CompanyID: companyId,  // Assuming this is a number or string
                PaymentTypeId: selectedPaymentmethodType?.value || null,
                CustomerTypeid: selectedCustomerType?.value || null,
                RouteID: selectedRouteType?.value || null,
                ContactNumber1: contactNumber1s || null,
                ContactNumber2: contactNumber2s || null,
                Email: emails || null,
                GSTNumber: gstNumbers || null,
                AddressLine1: addressline1s || null,
                // TallyId : Guid.NewGuid(),
                AddressLine2: addressline2s || null,
                LandMark: landMarks || null,
                PinCode: pincodes || null,
                Town: towns || null,
                District: districts || null,
                State: states || null,
                Country: countrys || null,
                GPSLocation: null,
                ContactPerson: contactPersons || null,
                CreatedBy: userId,  // Assuming this is numeric or valid string
                OpeningBalance: openingbal ? parseFloat(openingbal) : null,  // Ensure it's a number
                Gst: Gst || null,
                Remarks: Remarks?.length > 0 ? Remarks : null,  // Handle empty remarks properly
                Credit_Debit: selectedPaymentType || null,
                CreatedDate: new Date().toISOString(),  // Use ISO date format
                // New Fields
                OpeningTime: openingTime,  // Store AM/PM separately

                LunchBreak: LunchBreak,

                CustomerReview: customerReview || null, // Save Review Stars
            };

            postData('CustomerApi', CustomerCreateData, token)
                .then((response) => {
                    console.log('Customer Created success:', response);
                    // Reset form fields
                    setNames("");
                    setContactNumber1s("");
                    setContactNumber2s("");
                    setAddressLine1s("");
                    setAddressLine2s("");
                    setEmails("");
                    setGstNumbers("");
                    settallyId("");
                    setPinCodess("");
                    setLandMarks("");
                    setTowns("");
                    setcontactPersons("");
                    setDistricts("");
                    setStates("");
                    setCountrys("");
                    setOpeningBalance("");
                    setRemarks("");
                    setGst("");
                    setSelectedCustomerType("");
                    setSelectedRouteType("");
                    setSelectedPaymentmethodType("");
                    setCustomerpricetype("");
                    setSuccessMessages("Customer Created successfully!");
                    setErrorMessages(""); // Clear error message on success
                    // Reset new fields
                    setOpeningTime("");

                    setLunchBreak("");
                    setCustomerReview(0);
                    history.push('/customerIndex');
                })
                .catch((error) => {
                    console.error('Item Create error:', error);
                    setIsLoading(false);
                    setErrorMessages("Failed to create customer. Please try again.");
                });

        } catch (error) {
            console.error('Item Create error:', error);
            setIsLoading(false);
            setErrorMessages("An error occurred. Please try again.");
        }
    };



    /* End API */

    return (

        <Fragment>
            <div className="w-full max-w-sm container mt-6 mx-auto" style={{ width: '95%' }}>
                <div className="w-full mb-4 flex">

                    <form onSubmit={submitData}>

                        <div className='w-full mb-2 flex items-center' style={{ marginTop: '-10px' }}>
                            <h6 className='uppercase psheading flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>Customer Create</h6>


                            {/* <Tooltip title="Exit">
                                <Link to="/customerindex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                    <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                                        Back-To-List <ExitToAppIcon />
                                    </Button>
                                </Link>
                            </Tooltip>


                            <Tooltip title="SAVE">

                                <Button onClick={submitData} style={{ color: 'green', fontWeight: 'bolder' }} disabled={isLoading}>
                                    {isLoading ? <CircularProgress size={24} color="inherit" /> : "SAVE"} <CheckCircleIcon />
                                </Button>

                            </Tooltip> */}

                            <Button
                                variant="contained"
                                onClick={submitData}
                                className="linkcolor"
                                style={{ marginLeft: '8px', fontSize: '12px', fontWeight: 'bold', backgroundColor: '#ABBA7C' }}
                            >
                                Save

                            </Button>
                            <Button
                                variant="contained"
                                component={Link}
                                to="/CustomerIndex"
                                className="linkcolor"
                                style={{ marginLeft: '8px', fontSize: '12px', fontWeight: 'bold', backgroundColor: '#FF8383' }}
                            >
                                Back
                            </Button>

                        </div>
                        {errorMessages && <p className="text-red-500">{errorMessages}</p>}
                        {successMessages && <p className="text-green-500">{successMessages}</p>}
                        <br></br>
                        <div className="w-full flex flex-wrap" style={{ backgroundColor: 'rgba(201, 222, 219, 0.5)', padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>
                            <div className="w-full mb-4 flex" style={{ marginTop: '2px' }}>
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                        Route
                                    </label>

                                    <Select
                                        value={selectedRouteType}
                                        onChange={handleRouteTypeChange}
                                        options={routeOptions}
                                        placeholder="RouteOptions"
                                        isSearchable
                                    />
                                </div>
                                <div className="w-1/4 mr-2">

                                    <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                        Name
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={names}
                                        onChange={(e) => setNames(e.target.value)}
                                        type="text"
                                        placeholder="Enter Name"
                                    />
                                </div>

                                <div className="w-1/4 mr-2">

                                    <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                        Contact Person
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={contactPersons}
                                        onChange={(e) => setcontactPersons(e.target.value)}
                                        type="text"
                                        placeholder="Contact person"
                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                        Contact No:1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={contactNumber1s}
                                        onChange={(e) => setContactNumber1s(e.target.value)}
                                        type="text"
                                        placeholder="Contact Number 1"
                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                        Contact No:2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={contactNumber2s}
                                        onChange={(e) => setContactNumber2s(e.target.value)}
                                        type="text"
                                        placeholder="Contact Number 2"
                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                        Email
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={emails} onChange={(e) => setEmails(e.target.value)} type="text" placeholder="Email" />
                                </div>


                            </div>

                            <div className="w-full mb-4 flex" style={{ marginTop: '-10px' }}>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                        GST Number
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={gstNumbers} onChange={(e) => setGstNumbers(e.target.value)} maxLength={20} type="text" placeholder="GST Number" />
                                </div>


                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                        Address Line 1
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={addressline1s} onChange={(e) => setAddressLine1s(e.target.value)} type="text" placeholder="Address Line 1" />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                        Address Line 2
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={addressline2s} onChange={(e) => setAddressLine2s(e.target.value)} type="text" placeholder="Address Line 2" />
                                </div>

                            </div>
                            <div className="w-full mb-4 flex" style={{ marginTop: '-10px' }}>

                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                        PIN Code
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={pincodes} onChange={(e) => setPostcodes(e.target.value)} type="text" placeholder="PinCode" />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                        Land Mark
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={landMarks} onChange={(e) => setLandMarks(e.target.value)} type="text" placeholder="Landmark" />
                                </div>
                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                        Town
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={towns} onChange={(e) => setTowns(e.target.value)} type="text" placeholder="Town" />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                        District
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={districts} onChange={(e) => setDistricts(e.target.value)} type="text" placeholder="District" />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                        State
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={states} onChange={(e) => setStates(e.target.value)} type="text" placeholder="State" />
                                </div>
                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                        Country
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={countrys} onChange={(e) => setCountrys(e.target.value)} type="text" placeholder="Country" />
                                </div>
                            </div>
                            <div className="w-full mb-4 flex" style={{ marginTop: '-10px' }}>


                                <div className="w-1/6 mr-2">
                                    <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                        Payment Type
                                    </label>

                                    <Select
                                        value={selectedPaymentmethodType}
                                        onChange={handlePaymentTypeChange}
                                        options={paymentmethodOptions}
                                        placeholder="PaymentOption"
                                        isSearchable
                                    />
                                </div>
                                <div className="w-1/6 mr-2">
                                    <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                        Customer Type
                                    </label>

                                    <Select
                                        value={selectedCustomerType}
                                        onChange={handleCustomerTypeChange}
                                        options={customerTypeOptions}
                                        placeholder="Type Options"
                                        isSearchable
                                    />
                                </div>

                                <div className="w-1/7 mr-2" >
                                    <label className="block uppercase  text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                        Opening Balance
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={openingbal}
                                        onChange={(e) => {
                                            const input = e.target.value.replace(/\D/g, '');
                                            if (input.length <= 10) {
                                                setOpeningBalance(input);
                                            }
                                        }}
                                        type="text"
                                        placeholder="Opening balance"
                                    />
                                </div>

                                <div className="w-1/7 mr-2">
                                    <label className="block uppercase text-black tracking-wide text-xs font-bold mb-2">Opening & Closing Time</label>

                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={openingTime} onChange={(e) => setOpeningTime(e.target.value)} type="text" placeholder="opening&ClosingTime" />

                                </div>


                                {/* Lunchbrk Time */}
                                <div className="w-1/7 mr-2">
                                    <label className="block uppercase text-black tracking-wide text-xs font-bold mb-2">LunchBreak Time</label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={LunchBreak} onChange={(e) => setLunchBreak(e.target.value)} type="text" placeholder="LunchBreak" />

                                </div>
                                {/* Customer Review Stars */}
                                <div className="w-1/6 mr-2">
                                    <label className="block uppercase text-black tracking-wide text-xs font-bold mb-2" htmlFor="closingTime">
                                        Customer Rating
                                    </label>
                                    <div className="flex">
                                        {[1, 2, 3, 4, 5].map((star) => (
                                            <span
                                                key={star}
                                                className={`cursor-pointer text-2xl ${star <= customerReview ? 'text-yellow-400' : 'text-gray-600'
                                                    }`}
                                                onClick={() => setCustomerReview(star)}
                                            >
                                                ★
                                            </span>
                                        ))}
                                    </div>
                                </div>

                            </div>


                            <div className="w-1/2 mr-2">
                                <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                    Remarks
                                </label>
                                <textarea
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={Remarks}
                                    onChange={(e) => setRemarks(e.target.value)}
                                    placeholder=""
                                />

                            </div>
                            <div className="flex items-center">
                                <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                    <input type="radio" name="PaymentType" value="1"
                                        checked={selectedPaymentType === "1"}
                                        onChange={handleChange} />
                                    Credit
                                </label>
                                <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                    <input type="radio" name="PaymentType" value="2"
                                        checked={selectedPaymentType === "2"}
                                        onChange={handleChange} />
                                    Debit
                                </label>
                                <div className="flex items-center mt-2">
                                    <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                        <input
                                            type="checkbox"
                                            checked={Gst}
                                            onChange={(e) => setGst(e.target.checked)}

                                        />
                                        GST
                                    </label>
                                </div>
                            </div>
                        </div>


                    </form>
                </div>
            </div >
        </Fragment >
    );
}


